module.exports = __webpack_public_path__ + "static/media/megha.f78dcc7f.png";